import { render, staticRenderFns } from "./SimilarProducts.vue?vue&type=template&id=10dd477a&scoped=true&"
import script from "./SimilarProducts.vue?vue&type=script&lang=js&"
export * from "./SimilarProducts.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./SimilarProducts.vue?vue&type=style&index=0&id=10dd477a&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "10dd477a",
  null
  ,true
)

export default component.exports